import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import regeneratorRuntime from "/builds/lululemon/global-digital-tech/content-and-education/ecom-web-app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import Cookies from "js-cookie";
import { fetchFlagsForClient } from "@lululemon/mwa-launch-darkly";
import publicConfig from "@lululemon/ecom-core/src/public-config";
/**
 *   {
 *     flagName: string,   // The LaunchDarkly flag key
 *     name: string,       // The cookie name to set/remove
 *     routes: string[],   // An array of path prefixes for startsWith checks
 *   }
 *
 * For example, if your route can include product IDs (e.g. /p/:productId),
 * you can store "/p" in the routes array to match any path that starts with "/p":
 *
 *  {
 *    flagName: "v3-pdp-routing-controller",
 *    name: "lll-uf-pdp",
 *    routes: ["/p"],
 *  }
 *
 * The routes are used to control which views cookie-setting events will trigger reloads within.
 *
 * The array order matters: the first match "wins" and triggers a reload. This allows routes like story/gift-guide to not be effected by /story itself
 */ var rolloutCookieMap = [
    {
        flagName: "v3-bra-quiz-routing-controller",
        name: "lll-uf-bra-quiz",
        routes: [
            "/story/bra-quiz"
        ]
    },
    // Example of a more-specific route:
    {
        flagName: "v3-story-gift-guide-routing-controller",
        name: "lll-uf-story-gift-guide",
        routes: [
            "/story/gift-guide"
        ]
    },
    // Then a more-general route:
    {
        flagName: "v3-story-routing-controller",
        name: "lll-uf-story",
        routes: [
            "/story"
        ]
    },
    {
        flagName: "v3-search-routing-controller",
        name: "lll-uf-search",
        routes: [
            "/search"
        ]
    },
    {
        flagName: "v3-outfit-hub-routing-controller",
        name: "lll-uf-oh",
        routes: [
            "/outfit-hub"
        ]
    },
    {
        flagName: "v3-compare-routing-controller",
        name: "lll-uf-compare",
        routes: [
            "/c/compare"
        ]
    },
    {
        flagName: "v3-cdp-routing-controller",
        name: "lll-uf-cdp",
        routes: [
            "/c"
        ]
    },
    {
        flagName: "v3-pcdp-routing-controller",
        name: "lll-uf-personalized-cdp",
        routes: [
            "/pcdp"
        ]
    },
    {
        flagName: "v3-pdp-routing-controller",
        name: "lll-uf-pdp",
        routes: [
            "/p"
        ]
    },
    {
        flagName: "v3-size-guide-routing-controller",
        name: "lll-uf-size-guide",
        routes: [
            "/help/size-guide"
        ]
    },
    {
        flagName: "v3-home-page-routing-controller",
        name: "lll-uf-h",
        routes: [
            "/"
        ]
    }, 
];
/**
 * Utility to remove a leading locale segment (e.g. /en-ca, /fr-ca, /xx-xx) from a path if present
 *
 * Example:
 *  /en-ca/p/123 -> /p/123
 *  /p/123 -> /p/123
 */ function removeLocalePrefix(pathname) {
    // This regex looks for /xx-xx (two letters, dash, two letters) at the start of the path
    // and removes it. Case-insensitive.
    return pathname.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i, "");
}
// A small helper mostly to prevent "/" from matching all possible routes
function routeMatches(currentPath, routePrefix) {
    if (routePrefix === "/") {
        // special exact match for home
        return currentPath === "/";
    }
    // otherwise, default to a prefix check
    return currentPath.startsWith(routePrefix);
}
function fetchAllFlagsForUpperFunnel() {
    return _fetchAllFlagsForUpperFunnel.apply(this, arguments);
}
function _fetchAllFlagsForUpperFunnel() {
    _fetchAllFlagsForUpperFunnel = /**
 * Fetch flags for the upper-funnel-shell client using the LaunchDarkly clientId.
 * @returns {Object|null} - The set of flags from LaunchDarkly, or null if no clientId is found.
 */ _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var clientId;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    clientId = publicConfig.launchDarkly.upperFunnelAppshellClientSideId;
                    if (clientId) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 4:
                    _ctx.next = 6;
                    return fetchFlagsForClient({
                        clientId: clientId
                    });
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("V3Rollout: Error fetching LD flags:", _ctx.t0);
                    return _ctx.abrupt("return", null);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return _fetchAllFlagsForUpperFunnel.apply(this, arguments);
}
/**
 * Manage setting and removing rollout cookies based on LaunchDarkly flag values.
 * @param {Object} allFlags - The object containing all LaunchDarkly flags.
 * @returns {Array} newlySetCookies - An array of objects with shape { cookieName, routes }
 * where 'cookieName' is the name of the newly set cookie, and 'routes' is an array of route prefixes.
 */ function manageRolloutCookies(allFlags) {
    var newlySetCookies = [];
    // Iterate through the ordered array of flags
    rolloutCookieMap.forEach(function(param) {
        var flagName = param.flagName, cookieName = param.name, routes = param.routes;
        var flagValue = allFlags[flagName];
        if (flagValue === true) {
            // Check if the cookie already exists before setting it
            var cookieExisted = Cookies.get(cookieName);
            // Set a tiny cookie for the flag if it's enabled.
            // These cookies are read by Akamai to control routing to ecom-web-app or UpperFunnelShell origin
            Cookies.set(cookieName, "1", {
                path: "/",
                secure: true,
                sameSite: "Strict",
                expires: 7
            });
            // If the cookie was previously missing, mark it as newly set
            if (!cookieExisted && Cookies.get(cookieName)) {
                newlySetCookies.push({
                    cookieName: cookieName,
                    routes: routes
                });
            }
        } else {
            // Remove the cookie for the flag if it's disabled or undefined
            Cookies.remove(cookieName, {
                path: "/"
            });
        }
    });
    return newlySetCookies;
}
/**
 * Determine whether we should trigger a page reload based on newly set cookies
 * and the current browser route (with the locale prefix removed).
 * @param {Array} newlySetCookies - An array of objects with shape { cookieName, routes }.
 */ function manageReloadIfNeeded(newlySetCookies) {
    if (!newlySetCookies.length) return;
    var currentPathRaw = window.location.pathname;
    var currentPath = removeLocalePrefix(currentPathRaw);
    var reloadNeeded = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newlySetCookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var routes = _step.value.routes;
            var matched = !routes || routes.some(function(r) {
                return routeMatches(currentPath, r);
            });
            if (matched) {
                reloadNeeded = true;
                break; // early exit
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!reloadNeeded) return;
    var redirectGuardKey = "lll-uf-guard";
    var guardExists = Cookies.get(redirectGuardKey);
    if (!guardExists) {
        var expires = new Date(Date.now() + 20 * 60 * 1000);
        Cookies.set(redirectGuardKey, "1", {
            path: "/",
            secure: true,
            sameSite: "Strict",
            expires: expires
        });
        // Double-check we can read the guard cookie before triggering the reload, preventing reloads if guard is not set
        if (Cookies.get(redirectGuardKey)) {
            window.location.reload();
        }
    }
}
function initializeV3RolloutFlags() {
    return _initializeV3RolloutFlags.apply(this, arguments);
}
function _initializeV3RolloutFlags() {
    _initializeV3RolloutFlags = /**
 * Fetches rollout flags from LaunchDarkly and sets/removes cookies based on their values.
 * Then checks if we should reload based on newly set cookies.
 *
 * @description
 * - initializeV3RolloutFlags should execute exactly 1 time on application start
 * - initializeV3RolloutFlags should not execute on server.
 */ _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var allFlags, newlySetCookies;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(typeof document === "undefined")) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    if (!(process.env.JEST_WORKER_ID !== undefined)) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 4:
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return fetchAllFlagsForUpperFunnel();
                case 7:
                    allFlags = _ctx.sent;
                    if (allFlags) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 10:
                    newlySetCookies = manageRolloutCookies(allFlags);
                    // Possibly reload the page if a relevant route was newly activated
                    manageReloadIfNeeded(newlySetCookies);
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](4);
                    console.error("V3Rollout: An error occurred while managing V3 flags:", _ctx.t0);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                14
            ]
        ]);
    }));
    return _initializeV3RolloutFlags.apply(this, arguments);
}
export { initializeV3RolloutFlags };
